export const METHOD_GET = 'GET';
export const METHOD_PUT = 'PUT';
export const METHOD_POST = 'POST';
export const METHOD_PATCH = 'PATCH';
export const METHOD_DELETE = 'DELETE';

export const APIS = {
	ChangePassword: 'auth/change-password',
	faq: 'faqs',
	FörderProgramme: 'foerderprogramms',
	Person: 'persons',
	Organisation: 'organisations',
	'Online-Antrag': 'foerderantrags',
	'Portal-Nachricht': 'portal45nachrichts',
	Zuwendungsantrag: 'zuwendungsantrags',
	Mittelabruf: 'mittelabrufs',
	Verwendungsnachweis: 'verwendungsnachweiss',
	KostenKategories: 'kostenkategories',
	PushNotificaiton: 'push-notifications',
};
